<template>
  <div>
    <div class="topBg"></div>
    <div class="pageStyle" id="pageStyle">
      <div class="header">
        <div>
          <span>企业数据报告</span>
          <span>历史记录查看</span>
        </div>
        <div>实时查看企业报告填写记录</div>
      </div>
      <div class="content">
        <div class="content-title">
          <van-search
            v-model="queryValue"
            :placeholder="
              searchValue == '个人版' ? '请输入客户姓名' : '请输入公司名称'
            "
            shape="round"
            show-action
            left-icon=""
            @clear="clearEntName"
            @search="onSearch"
            ><template #action>
              <div @click="onSearch">搜索</div>
            </template>
            <template #label>
              <van-popover
                v-model="showPopover"
                trigger="click"
                :actions="actions"
                @select="searchValueChange"
                class="searchValueChange"
              >
                <template #reference>
                  <div class="searchValueBox">
                    <van-button>
                      <div class="searchValue">
                        {{ searchValue }}
                        <img
                          src="https://static.xchengtech.cn/5d3efe66c2424b1fa1a74a4f0d55ae0f.png"
                          alt=""
                        />
                      </div>
                    </van-button>
                  </div>
                </template>
              </van-popover>
            </template>
          </van-search>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="item-box">
            <div class="item" v-for="(item, index) in dataList" :key="index">
              <div
                class="settled"
                v-show="item.status === '4' || item.status === '0'"
              >
                <div class="isSettled" v-if="item.settled === true">
                  <img
                    src="https://static.xchengtech.cn/13be6d0fd94e4072803528b5966908af.png"
                    alt=""
                  />
                  <span>已结算</span>
                </div>
                <div class="noSettled" v-else>
                  <img
                    src="https://static.xchengtech.cn/08c0321047bc4e6db3183f265d24511c.png"
                    alt=""
                  />
                  <span>未结算</span>
                </div>
                <!-- 结算金额 -->
                <div class="settledAmount" v-show="depName == 'zwrx'">
                  <span style="color: #1989fa" v-if="item.settled === true"
                    >已结算金额：50元</span
                  >
                  <span style="color: #ed6a0c" v-else>待结算金额：50元</span>
                </div>
              </div>
              <div class="top">
                <div class="items">
                  <div class="left">
                    {{
                      item.repoType == "besoPerson"
                        ? item.userName
                          ? item.userName
                          : "-"
                        : item.entName
                    }}
                  </div>
                  <div class="right">{{ getStatusLabel(item.status) }}</div>
                </div>
              </div>
              <div class="bottom">
                <div class="items">
                  <span>报告类型：</span>
                  <span>{{ getRepType(item.repoType) }}</span>
                </div>
                <div class="items" v-show="item.repoType !== 'besoPerson'">
                  <span>企业税号：</span>
                  <span> {{ item.creditCode }}</span>
                </div>
                <div class="items">
                  <span>联系电话：</span>
                  <span>{{
                    item.userPhoneNum ? item.userPhoneNum : item.phone
                  }}</span>
                </div>

                <div class="items">
                  <span>订单金额：</span>
                  <span>{{ item.amt / 100 }} 元</span>
                </div>

                <div class="items">
                  <span>归属渠道：</span>
                  <span>{{ getChannelName(item.channelId) }}</span>
                </div>
                <div class="items">
                  <span>创建时间：</span>
                  <span>{{ parseTime(item.createDateTime) }}</span>
                </div>
              </div>
              <div
                class="btn"
                v-show="item.status == '4'"
                :style="
                  item.repoType != 'besoPerson'
                    ? 'grid-template-columns: repeat(2, 1fr)'
                    : ''
                "
              >
                <!-- 类型为企业版报告 仅绩效会、会计师事务所可见 -->
                <div @click="toPage('reportInterpre', { repId: item.id })">
                  AI解读
                </div>
                <div @click="toDownLoad(item)">下载报告</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <!-- 结算信息 -->
      <div class="foot">
        <div>
          <span>{{ this.dataList.length }}</span>
          <span>总订单数</span>
        </div>
        <div>
          <span>{{ this.getTotalAmount().totalUnsettled }}</span
          ><span>待结算(元)</span>
        </div>
        <div>
          <span>{{ this.getTotalAmount().totalSettled }}</span
          ><span>已结算(元)</span>
        </div>
      </div>
    </div>
    <!-- 选择进件产品 -->
    <van-popup
      v-model="applyPopupShow"
      position="bottom"
      :style="{ height: '30%' }"
      ><van-picker
        title="选择进件产品"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
    /></van-popup>
    <!-- 展示图片弹窗 -->
    <van-dialog
      class="imgDialogShow"
      v-model="imgDialogShow"
      :show-confirm-button="false"
    >
      <img :src="imgDialogImg" />
      <!-- 关闭按钮 -->
      <div class="closeIcon">
        <van-icon name="close" @click="imgDialogShow = !imgDialogShow" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Field,
  Toast,
  Dialog,
  Notify,
  Form,
  List,
  Icon,
  Empty,
  Picker,
  Popup,
  Popover,
} from "vant";
Vue.use(Form);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(List);
Vue.use(Dialog);
Vue.use(Picker);
Vue.use(Popover);
Vue.use(Popup);
import Vue from "vue";
import { getToken } from "@/utils/auth.js";
import {
  xcCompanyRep,
  channgeFileName,
  queryReportFile,
  getProductApplyCode,
  searchIdByProductNameAndDepName,
} from "@/api/companyRep.js";
import { getDepNameByDomain } from "@/utils/index";
import { getCus as cusGetDict } from "@/api/dictDetail.js";
import { getCurrentChannelInfo } from "@/api/login.js";
import { getDynamicDict } from "@/api/xcCustomer.js";
export default {
  data() {
    return {
      depName: getDepNameByDomain(),
      imgDialogShow: false,
      imgDialogImg: "",
      applyPopupShow: false,
      columns: ["微业贷"],
      channelList: {},
      dataList: [],
      dataListForShow: [],
      form: {
        size: 100,
        page: 0,
        sort: "createDateTime,desc",
      },
      loading: false,
      finished: false,
      status: [
        { value: "1", label: "采集中" },
        { value: "-1", label: "采集失败" },
        { value: "2", label: "处理中" },
        { value: "3", label: "处理失败" },
        { value: "4", label: "采集完成" },
        { value: "0", label: "已支付" },
        { value: "-2", label: "未支付" },
        { value: "-3", label: "已退款" },
      ],
      repType: [
        {
          value: "besoBase",
          label: "企业经营基础报告",
        },
        {
          value: "besoPro",
          label: "企业涉税风险报告",
        },
        {
          value: "besoPerson",
          label: "个人信息报告",
        },
      ],
      queryValue: "",
      channelInfo: {},
      applyCompanyRepoId: "",
      searchValue: "企业版",
      showPopover: false,
      actions: [{ text: "企业版" }, { text: "个人版" }],
      getDataFlag: false,
    };
  },
  mounted() {
    // 判断是否登录
    this.isLogin();
  },
  computed: {},
  methods: {
    // 判断是否登录
    isLogin() {
      // 已登录 获取微信信息
      if (getToken()) {
        this.getDataFlag = true;
        this.getStatus();
        this.loadChannelList();
        getCurrentChannelInfo()
          .then((res) => {
            // console.log("res", res);
            this.channelInfo = res;
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      // 没登陆 跳转至指定登录页
      else {
        this.$router.push({ path: "/login" });
      }
    },
    toPage(name, query) {
      query.channelId = this.channelInfo.id;
      this.$router.push({ path: "/reportInterpre", query: query });
    },
    // 合计待结算订单和已结算订单
    getTotalAmount() {
      // 已结算
      let totalSettled = 0;
      // 待结算
      let totalUnsettled = 0;
      this.dataList.forEach((item) => {
        // 订单状态为已支付和采集完成 才判断是否已结算
        if (item.status === "0" || item.status === "4") {
          // 判断结算标识是否为true
          if (item.settled === true) {
            totalSettled = totalSettled + 50;
          } else {
            totalUnsettled = totalUnsettled + 50;
          }
        }
      });
      return {
        totalSettled,
        totalUnsettled,
      };
    },
    // 加载渠道列表（带缓存）
    loadChannelList() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      getDynamicDict("dep_channel_dict")
        .then((res) => {
          if (Array.isArray(res)) {
            this.processChannelData(res);
          }
        })
        .catch((err) => {
          console.error("获取渠道列表失败:", err);
        })
        .finally(() => {
          Toast.clear();
        });
    },
    // 处理渠道数据
    processChannelData(data) {
      // 清空现有数据（创建新对象确保响应式更新）
      this.channelList = {};

      // 只存储需要的字段
      data.forEach((item) => {
        if (
          item.value != null &&
          item.value !== "" &&
          item.label != null &&
          item.label !== ""
        ) {
          // 确保key是字符串类型，避免类型不匹配问题
          const key = String(item.value);
          const value = String(item.label);

          // 使用Vue.set或直接赋值确保响应式更新
          this.$set(this.channelList, key, value);
        }
      });
    },
    searchValueChange(action) {
      this.searchValue = action.text;
      // this.showPopover = false;
      // Toast(action.text);
    },
    // 获取渠道名称
    getChannelName(channelId) {
      // 确保channelId是字符串类型
      const key = String(channelId);
      return this.channelList[key] || "";
    },
    getStatus() {
      cusGetDict("company_rep_status")
        .then((res) => {
          this.status = res;
          console.log("res", res);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 立即进件 选择产品
    onConfirm(e) {
      Toast.loading({
        message: "加载中",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
        overlay: true,
      });
      // 获取产品id
      searchIdByProductNameAndDepName(e)
        .then((res) => {
          // 获取进件码
          let body = {
            productId: res,
            channelId: this.channelInfo.id,
            companyRepoId: this.applyCompanyRepoId,
          };
          getProductApplyCode(body)
            .then((ress) => {
              Toast.clear();
              this.imgDialogShow = true;
              this.imgDialogImg = ress;
              this.applyPopupShow = false;
              console.log("ress", ress);
            })
            .catch((errr) => {
              Toast.clear();
              console.log("errr", errr);
            });
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    onCancel() {
      this.applyPopupShow = !this.applyPopupShow;
    },
    getRepType(value) {
      if (value) {
        let s = this.repType.find((item) => {
          return item.value == value;
        });
        if (s) {
          return s.label;
        } else {
          return value;
        }
      } else {
        return value;
      }
    },
    clearEntName() {
      this.form.entNameLike = "";
      this.onSearch();
    },
    onLoad() {
      if (!this.getDataFlag) {
        return false;
      }
      this.loading = true;
      this.getData();
    },
    onSearch() {
      this.form.page = 0;
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      // 先判断是否有查询条件
      if (this.queryValue) {
        // 判断查询类型
        if (this.searchValue == "个人版") {
          this.form.userNameLike = this.queryValue;
          delete this.form.entNameLike;
        } else {
          this.form.entNameLike = this.queryValue;
          delete this.form.userNameLike;
        }
      }
      // 没有查询条件 默认查询
      else {
        delete this.form.entNameLike;
        delete this.form.userNameLike;
      }

      this.getData();
    },
    getData() {
      xcCompanyRep(this.form)
        .then((res) => {
          this.dataList = this.dataList.concat(res.content);
          this.loading = false;
          this.form.page++;
          if (res.content.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          Toast.clear();
          this.loading = false;
          this.finished = true;
          console.log("err", err);
        });
    },
    toDownLoad(row) {
      Toast.loading({
        message: "加载中",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
        overlay: true,
      });
      queryReportFile(row.id)
        .then((res) => {
          console.log("res", res);
          Toast.clear();
          window.location.href = res.url;
          // if (res && res.length > 0) {
          //   res.forEach((item) => {
          //     let body = {
          //       url: item.url,
          //       fileName: item.describe + "-" + row.entName,
          //     };
          //     channgeFileName(body)
          //       .then((ress) => {
          //         console.log("ress", ress);
          //         Toast.clear();
          //         window.location.href = ress.url;
          //       })
          //       .catch((err) => {
          //         Toast.clear();
          //       });
          //   });
          // } else {
          //   Toast.clear();
          //   Toast("无文件");
          // }
        })
        .catch((err) => {
          Toast.clear();
        });
    },
    // 获取状态标签
    getStatusLabel(value) {
      let s = this.status.find((item) => {
        return item.value == value;
      });
      if (s) {
        return s.label;
      } else {
        return value;
      }
    },
    parseTime(time) {
      if (time) {
        var date = new Date(time);
        var year = date.getFullYear();
        /* 在日期格式中，月份是从0开始的，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        var month =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hours =
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var seconds =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // 拼接
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.topBg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -99;
  width: 100%;
  background-image: linear-gradient(to bottom, #3776ff 50%, white 100%);
  height: 100vw;
}
.pageStyle {
  padding-bottom: 24vw;

  font-size: 4vw;
}
.header {
  padding: 4vw;

  background-image: url("https://static.xchengtech.cn/18766b0585cb4c2a83ecefcc4d7781d2.png");
  background-repeat: no-repeat;
  background-position: right 3vw bottom 3vw;
  background-size: 32vw auto;
}

.header div:nth-of-type(1) {
  /* padding-top: 2vw; */
}
.header div:nth-of-type(1) span {
  font-size: 9.4vw;
  display: inline-block;
  font-weight: 600;
  color: white;
}
.header div:nth-of-type(2) {
  padding-top: 3vw;
  font-size: 3.5vw;
  display: inline-block;
  font-weight: 600;
  color: white;
}
.content {
  /* background-color: white; */
  /* padding: 4vw; */
  margin: 0 4vw 0 4vw;
  display: grid;
  /* grid-template-columns: repeat(2, 1fr); */
  gap: 4vw;
  border-radius: 16px;
}
.content-title {
  border-radius: 12px;
}
.content-title .van-search__action {
  background-color: unset;
  color: white;
  /* font-size: 4vw; */
  padding: 0 1vw 0 3vw;
}
.content-title .van-search__content {
  background-color: white;
}
.content-title .van-search {
  padding: 0;
  background-color: unset;
}
.content-title .van-cell {
  /* padding: 2vw 3vw 2vw 0; */
  /* font-size: 4vw; */
  display: flex;
  align-items: center;
}
.content .item-box {
  display: grid;
  /* grid-template-columns: repeat(2, 1fr); */
  gap: 4vw;
}
.content .item {
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.content .item .top {
  padding: 3vw 4vw 0 4vw;
}
.content .item .top .items {
  display: grid;
  grid-template-columns: auto 20vw;
  align-items: flex-start;
}
.content .item .top .items .left {
  font-size: 4.2vw;
  font-weight: 600;
}
.content .item .top .items .right {
  text-align: right;
  color: #3776ff;
  font-weight: 600;
  font-size: 4.2vw;
}
.content .item .bottom {
  /* display: grid;
  gap: 3vw; */
  padding: 0 4vw 4vw 4vw;
}
.content .item .bottom .items {
  padding-top: 3vw;
  font-size: 3.6vw;
  color: #696971;
}
.content .item .bottom .items span:nth-of-type(1) {
  color: #969799;
}
.content .item .bottom .items span:nth-of-type(2) {
  color: black;
}
.content .item .btn {
  padding: 0 4vw 4vw 4vw;
  text-align: center;
  display: grid;
  text-align: center;
  align-items: center;
  gap: 4vw;
  font-weight: 600;
}
.content .item .btn div:nth-of-type(1) {
  padding: 3vw 0;
  border-radius: 35px;
  border: 1px solid #3776ff;
  color: #3776ff;
}
.content .item .btn div:nth-of-type(2) {
  padding: 3vw 0;
  border-radius: 8px;
  border-radius: 35px;
  background-color: #3776ff;
  color: white;
  border: 1px solid #3776ff;
}
.settled {
  position: relative;
}
/* 结算金额 */
.settledAmount {
  position: absolute;
  top: 3vw;
  right: 4vw;
}
.settled span {
  font-weight: 600;
  font-size: vw;
}
.settled .isSettled {
  background-color: #ecf9ff;
  border-radius: 16px 16px 0 0;
  display: flex;
  align-items: center;
  padding: 3vw 4vw 3vw 4vw;
  color: rgb(25, 137, 250);
  gap: 2vw;
}
.settled img {
  display: block;
  height: 4vw;
}
.settled .noSettled {
  background-color: #ffe99f6e;
  border-radius: 16px 16px 0 0;
  display: flex;
  align-items: center;
  padding: 3vw 4vw 3vw 4vw;
  color: #ed6a0c;
  gap: 2vw;
}
.imgDialogShow {
  overflow: visible;
}
.imgDialogShow img {
  display: block;
  padding: 4vw;
  width: 100%;
}
.imgDialogShow .closeIcon {
  position: absolute;

  bottom: -22vw;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
}
.imgDialogShow .closeIcon .van-icon {
  font-size: 10vw;
  color: white;
}
.searchValueBox .van-button {
  margin-left: 1vw;
  padding: 0 2vw 0 0;
  border: none;
}
.searchValue {
  display: flex;
  align-items: center;
  gap: 1vw;
}

.searchValue img {
  display: block;
  width: 2.2vw;
}
.interpret-content {
  padding: 6vw 4vw 6vw 4vw;
}
.interpret-content .title {
  font-size: 5vw;
  font-weight: 600;
  text-align: center;
  padding-bottom: 6vw;
}
.interpret-content .top div:nth-of-type(1) {
  text-align: center;
  padding-bottom: 2vw;
  font-size: 6vw;
  font-weight: 600;
  padding-bottom: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1vw;
}
.interpret-content .top div:nth-of-type(1) img {
  display: block;
  height: 7vw;
}
.interpret-content .top div:nth-of-type(2) {
  display: flex;
  justify-content: center;
  padding-bottom: 2vw;
}
.interpret-content .top div:nth-of-type(2) img {
  display: block;
  width: 16vw;
}
.interpret-content .bottom {
  display: grid;
  justify-content: center;
  text-align: center;
}
.interpret-content .bottom span:nth-of-type(1) {
  font-size: 4.2vw;
  font-weight: 600;
  padding-bottom: 1vw;
}
.interpret-content .bottom span:nth-of-type(2) {
  color: #696971;
}
.foot {
  padding: 4vw;
  background-color: white;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
  font-size: 3.6vw;
}
.foot div {
  display: grid;
  gap: 1vw;
  text-align: center;
}
.foot div span:nth-of-type(2) {
  font-size: 3.6vw;
}
.foot div span:nth-of-type(1) {
  font-size: 4.8vw;
  font-weight: 600;
}
.foot div:nth-of-type(1) span:nth-of-type(2) {
  /* color: #3776ff; */
}
.foot div:nth-of-type(3) span {
  color: #3776ff;
}
.foot div:nth-of-type(2) span {
  color: #ed6a0c;
}
/* .foot div:nth-of-type(3) span {
  color: #ed6a0c;
}
.foot div:nth-of-type(2) span {
  color: #3776ff;
} */
</style>


// WEBPACK FOOTER //
// src/view/reportCommon/companyRepByReport.vue